"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var errors = _interopRequireWildcard(require("./errors-const"));

var _promoMusictrack = _interopRequireDefault(require("../components/promo-musictrack"));

var _typesConst = require("../const/types-const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import {
//     getClipByGuid, normalizeClipObject, getRatioObjectBy, getClipPreviewUrls,
// } from '../utils';
let map; // tween max timeline

let timeline;

class MusicViewService {
  constructor(config) {
    if (config) {
      this.logger = config.logger || function () {};
    }

    this.volumeLevel = 1;
    this.mutedValue = false; // set new map

    map = config.map; // set time line

    timeline = config.timeline; // set actions

    const {
      play,
      pause,
      time
    } = config;
    this.play = play;
    this.pause = pause;
    this.time = time;
  }

  set volume(value) {
    this.volumeLevel = value;

    if (map.has(_typesConst.MUSIC)) {
      const {
        promoMusictrack
      } = map.get(_typesConst.MUSIC);
      promoMusictrack.volume = this.volumeLevel;
    }
  }

  get volume() {
    return this.volumeLevel;
  }

  set muted(value) {
    this.mutedValue = value;

    if (map.has(_typesConst.MUSIC)) {
      const {
        promoMusictrack
      } = map.get(_typesConst.MUSIC);
      promoMusictrack.muted = this.mutedValue;
    }
  }

  get muted() {
    return this.mutedValue;
  }

  onSeek(time) {
    if (map.has(_typesConst.MUSIC)) {
      const {
        promoMusictrack
      } = map.get(_typesConst.MUSIC);
      promoMusictrack.currentTime = time;
    }
  }

  async onPlay(time, muted) {
    if (map.has(_typesConst.MUSIC)) {
      const {
        promoMusictrack
      } = map.get(_typesConst.MUSIC);
      promoMusictrack.currentTime = time;
      promoMusictrack.muted = muted === undefined ? this.mutedValue : muted;

      try {
        await promoMusictrack.play();
      } catch (error) {
        // if get error when play audio it can
        // be blocked by user denied permission
        // we will paused the video
        this.pause();
        this.time(0.25); // go to the first frame
        // NotAllowedError
        // eslint-disable-next-line no-console

        console.warn(error);
      }
    }
  }

  onPaused() {
    if (map.has(_typesConst.MUSIC)) {
      const {
        promoMusictrack
      } = map.get(_typesConst.MUSIC);
      promoMusictrack.pause();
    }
  }

  clear() {
    map.forEach((value, key) => {
      if (value && value.promoMusictrack) {
        this.destroy(key);
      }
    });
  }

  async create(data) {
    if (!data) {
      throw errors.INVALID_PARMS;
    }

    const {
      music,
      duration
    } = data;

    if (!music || !duration) {
      throw errors.PROMO_MUSIC_DATA_MISSING;
    } // clear


    this.clear();
    await Promise.all(music.map(async track => {
      await this.render(track, duration);
    }));
  }

  async render(track, videoDuration) {
    if (!_.isObject(track)) {
      throw errors.INVALID_PARMS;
    }

    if (map.has(_typesConst.MUSIC)) {
      this.destroy(_typesConst.MUSIC);
    }

    await new Promise(resolve => {
      const promoMusictrack = new _promoMusictrack.default(track, videoDuration);
      const volumeTo = 0;
      const fadeOutTransition = promoMusictrack.fadeOutTransition;

      const outTween = _gsap.TweenMax.to(promoMusictrack, fadeOutTransition.duration, {
        startAt: {
          volumeLevel: 1
        },
        volumeLevel: volumeTo,
        ease: _gsap.Linear.easeNone,
        onUpdateParams: [promoMusictrack, '{self}'],
        // eslint-disable-next-line no-shadow
        onUpdate: (promoMusictrack, self) => {
          if (self.ratio === 0) {
            promoMusictrack.volume = this.volumeLevel;
          } else {
            promoMusictrack.volume = this.volumeLevel * self.target.volumeLevel;
          }
        },
        onStart: () => {
          this.logger.log('music onStart - fadeout');
        },
        onComplete: () => {
          this.logger.log('music onCopmlete - fadeout');
        }
      });

      promoMusictrack.tweens.push(outTween);
      timeline.add(outTween, fadeOutTransition.start);
      map.set(_typesConst.MUSIC, {
        promoMusictrack,
        destroyFunc: promoMusictrack.destroy()
      });
      promoMusictrack.isReady.then(() => {
        this.logger.log('music - oncanplaythrough', _typesConst.MUSIC);
        resolve(promoMusictrack);
      });
    });
  }

  destroy(guid) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.MUSIC_NOT_RENDERED;
    }

    if (map.has(guid)) {
      const {
        destroyFunc
      } = map.get(guid);
      destroyFunc.call();
      map.delete(guid);
    }
  }

}

exports.default = MusicViewService;